import { createContext } from 'react';
const loginContextDefault = {
    onLoginSuccess: undefined,
    onForgotPassword: undefined,
    labels: undefined,
    errors: undefined,
    formInputOptions: {
        emailAddress: undefined,
        password: undefined,
    },
};
const LoginContext = createContext(loginContextDefault);
export default LoginContext;
//# sourceMappingURL=LoginContext.js.map